import { createContext, useContext } from 'react'
import type { DataState } from '@/lib/demo/demo-context'

export const ScreenStateContext = createContext<DataState>('populated')

/** The state set by the nearest `<ScreenState>`. */
export function useScreenState(): DataState {
  return useContext(ScreenStateContext)
}
